import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type {
  IsUserLoggedFromUserAccountQuery,
  IsUserLoggedFromUserAccountQueryVariables,
} from "~/generated/graphql";
import { IS_USER_LOGGED_QUERY } from "../providers/operations/IsUserLoggedFromUserAccount";

export interface IsLoggedInUser {
  errors: UseQueryResult<
    IsUserLoggedFromUserAccountQuery,
    IsUserLoggedFromUserAccountQueryVariables
  >["errors"];
  loading: UseQueryResult<
    IsUserLoggedFromUserAccountQuery,
    IsUserLoggedFromUserAccountQueryVariables
  >["loading"];
  data: UseQueryResult<
    IsUserLoggedFromUserAccountQuery,
    IsUserLoggedFromUserAccountQueryVariables
  >["data"];
}

const useIsLoggedInUser = (): IsLoggedInUser => {
  const { data, loading, errors } = useQuery<
    IsUserLoggedFromUserAccountQuery,
    IsUserLoggedFromUserAccountQueryVariables
  >(IS_USER_LOGGED_QUERY, {
    variables: {},
  });
  return {
    data,
    loading,
    errors,
  };
};

export default useIsLoggedInUser;
